import script from "./FranchiseHome.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseHome.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FranchiseLeaderboard from "@/components/franchise/FranchiseLeaderboard.vue";
import FranchiseMerchantSwitcher from "@/components/franchise/FranchiseMerchantSwitcher.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import ProductionDayCalendar from "@/components/activity/ProductionDayCalendar.vue";
import ReportChart from "@/components/reports/ReportChart.vue";
import ReportDateRangeFilter from "@/components/reports/ReportDateRangeFilter.vue";
import ReportDelta from "@/components/reports/ReportDelta.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import StatTile from "@/components/customers/record/StatTile.vue";
script.components = Object.assign({}, { FranchiseLeaderboard, FranchiseMerchantSwitcher, NeueLoading, ProductionDayCalendar, ReportChart, ReportDateRangeFilter, ReportDelta, SecondaryNav, SecondaryTop, StatTile }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FranchiseLeaderboard, FranchiseMerchantSwitcher, NeueLoading, ProductionDayCalendar, ReportChart, ReportDateRangeFilter, ReportDelta, SecondaryNav, SecondaryTop, StatTile }, script.__o.components);}